<template>
  <div v-if="suppliers">

    <v-card class="ma-1" outlined>

      <v-card-title >
        Furnizor
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 98px;">

        <template v-if="!c_supplier.contact || !c_supplier.financial">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Acest hotel nu are furnizor!
            </v-row>
          </v-alert>
        </template>

        <template v-else>
          <div>
            <small>Nume: </small>
            {{c_supplier.contact.name}}
          </div>
          <div>
            <small>CUI: </small>
            {{c_supplier.financial.cui}}
          </div>
          <div>
            <small>Nr. Reg. Com.: </small>
            {{c_supplier.financial.reg_com}}
          </div>
        </template>
      </v-card-text>

    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary title white--text" flat dark>
          Furnizor
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-3 pt-1">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-black ma-1">Furnizor</div>
            </v-col>
            <v-col cols="12">
              <v-select v-model="hotel.supplier_id" label="Furnizor" class="ma-1" :items="supplier_items" outlined dense hide-details/>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="c_supplier.financial.cui" label="CUI" class="ma-1" outlined dense hide-details readonly disabled/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="c_supplier.financial.reg_com" label="Nr. Reg. Comercial" class="ma-1" outlined dense hide-details readonly disabled/>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-black ma-1">Banca</div>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="c_supplier.financial.bank.name" label="Nume" class="ma-1" outlined dense hide-details readonly disabled/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="c_supplier.financial.bank.iban" label="IBAN" class="ma-1" outlined dense hide-details readonly disabled/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="c_supplier.financial.bank.currency" label="Valuta" class="ma-1" outlined dense hide-details readonly disabled/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>

</template>

<script>

  import supplier_repository from '@/repositories/supplier-repository'

  export default {

    props: {
      hotel: Object
    },

    data: () => ({
      dialog: false,
      suppliers: null,
      supplier_items: null
    }),

    async created() {
      try {
        this.suppliers = await supplier_repository.getSuppliers(null, {page: 1, size: 1000});
        this.supplier_items = await this.suppliers.data.map(supplier => ({text: supplier.contact.name, value: supplier.id}));
      } catch (e) {
        await this.$store.dispatch('alert/error', e);
      }
    },

    computed: {
      c_supplier: {
        get() {
          if (!this.suppliers)
            return null;
          return _.head(this.suppliers.data.filter(supplier => supplier.id === this.hotel.supplier_id));
        }
      }
    },

    methods: {
      save() {
        this.$emit('save');
        this.dialog = false;
      },

      cancel() {
        this.$emit('cancel');
        this.dialog = false;
      }
    }

  }
</script>